import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Container, Card, Button, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle, faSort } from '@fortawesome/free-solid-svg-icons'
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "./TableContainer"
import { useSelector, useDispatch } from "react-redux";
import { selectCsoAllSurveys, csoAllSurveys } from "../csoallsurveys/csoAllSurveysSlice";
import { HomePageBanner } from "../homepage-banner/banner";
import { listTemplates, selectTemplates, clearTemplates } from '../downloadtemplate/listTemplatesSlice'

export const AllocatedSurveyDataCsoAdmin = () => {

  const dispatch = useDispatch();
  let surveys = useSelector(selectCsoAllSurveys);
  const templates = useSelector(selectTemplates);


  useEffect(() => {
    dispatch(clearTemplates());
    dispatch(csoAllSurveys());
  }, [dispatch]);

  useEffect(() => {
    if (surveys && surveys.length > 0) {
      fetchTemplates();
    }
  }, [surveys]);

  function byKeyStartDate(arr, key) {
    const keySK = key.SK
    for (var i = 0, L = arr.length; i < L; i++) {
      if (arr[i].SK === keySK) {
        if (arr[i].PINStartDate) {
          return arr[i].PINStartDate
        } else {
          return key.survey_start_date
        }
      }
    }
  }

  function byKeyEndDate(arr, key) {
    const keySK = key.SK
    for (var i = 0, L = arr.length; i < L; i++) {
      if (arr[i].SK === keySK) {
        if (arr[i].PINEndDate) {
          return arr[i].PINEndDate
        } else {
          return key.survey_end_date
        }
      }
    }
  }

  function dateFormat(longDate) {
    if (longDate && longDate !== "" && longDate !== " ") {
      const unixStamp = Date.parse(longDate);
      const newDate = new Date(unixStamp)
      const dateString = newDate.getDate().toString() +
        "/" + (newDate.getMonth() + 1).toString() +
        "/" + newDate.getFullYear().toString()
      return dateString;
    } else return null;
  }

  function byKeyPK(arr, key) {
    for (var i = 0, L = arr.length; i < L; i++) {
      if (arr[i].survey_id === key) {
        return arr[i].PK;
      }
    }
  }

  const fetchTemplates = () => {
    if (surveys && surveys.length > 0) {
      surveys.map((surveyRow) => {
        dispatch(listTemplates(byKeyPK(surveys, surveyRow.survey_id)));
      });
    }
  };

  let allSurveys = []

  if (surveys && surveys.length > 0) {
    surveys.map((surveyRow) => {
      return allSurveys.push({
        id: surveyRow.PK,
        title: surveyRow.author_title,
        start_date: dateFormat(byKeyStartDate(surveys, surveyRow)),
        end_date: dateFormat(byKeyEndDate(surveys, surveyRow)),
        download: surveyRow.SK.slice(7),
        upload: surveyRow.survey_id
      })
    })
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Survey Title',
        accessor: 'title',
        disableFilters: false,
        disableSortBy: false
      },
      {
        disableFilters: true,
        disableSortBy: false,
        Header: () => (
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 300 }}
            overlay={(
              <Popover id="popover-basic">
                Sort surveys by start date
              </Popover>
            )} >
            <div>
              Start Date <FontAwesomeIcon icon={faSort} />
            </div>
          </OverlayTrigger>
        ),
        sortable: true,
        resizable: false,
        accessor: 'start_date',
        Cell: props => (
          <div style={{ textAlign: "left" }}>
            {props.value}
          </div>
        )
      },
      {
        disableFilters: true,
        disableSortBy: false,
        Header: () => (
          <OverlayTrigger
            placement="top"nload
            delay={{ show: 150, hide: 300 }}
            overlay={(
              <Popover id="popover-basic">
                Sort surveys by end date
              </Popover>
            )} >
            <div>
              End Date <FontAwesomeIcon icon={faSort} />
            </div>
          </OverlayTrigger>
        ),
        sortable: true,
        resizable: false,
        accessor: 'end_date',
        Cell: props => (
          <div style={{ textAlign: "left" }}>
            {props.value}
          </div>
        )
      },
      {
        Header: () => (
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 300 }}
            overlay={<Popover id="popover-basic">Use this button to download templates required to fill out the survey.</Popover>}
          >
            <div>Download Template <FontAwesomeIcon icon={faQuestionCircle} /></div>
          </OverlayTrigger>
        ),
        accessor: 'download',
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value }) => {
          const hasTemplate = templates.some(templateFile => templateFile.Key && templateFile.Key.includes(value));
          return (
            <div style={{ textAlign: "center" }}>
              {hasTemplate ? (
                <Link to={`/home/download/${value}`}>
                  <Button variant="warning">Download Template</Button>
                </Link>
              ) : (
                <Button
                  disabled
                  style={{
                    cursor: "not-allowed",
                    color: "rgba(0, 0, 0, 0.65)",
                    borderColor: "grey",
                    backgroundColor: "#d3d3d3",
                    opacity: 1,
                  }}
                >
                  Not Applicable
                </Button>
              )}
            </div>
          );
        },
      },
      {
        disableFilters: true,
        disableSortBy: true,
        Header: () => (
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 300 }}
            overlay={(
              <Popover id="popover-basic">
                Use this button to upload templates to accompany the survey.
              </Popover>
            )} >
            <div>
              Upload Templates <FontAwesomeIcon icon={faQuestionCircle} />
            </div>
          </OverlayTrigger>
        ),
        sortable: false,
        resizable: false,
        accessor: 'upload',
        Cell: props => (
          <div style={{ textAlign: "center" }}>
            <Link to={`/home/uploadcso/${props.value}`}>
              <Button variant="secondary">Upload File</Button>
            </Link>
          </div>
        )
      }
    ],
    [templates]
  )

  return (
    <Col style={{ paddingLeft: 50, paddingRight: 50 }}>
      <Container fluid className='pt-5'>
        <HomePageBanner />
        <Card>
          <Card.Header style={{ backgroundColor: "#FBAA34", color: "white" }}>
            <h3 style={{ textAlign: 'left', float: 'left' }}>Available Surveys &nbsp;</h3>
          </Card.Header>
          <Card.Body>
            {surveys && surveys.length > 0 ? (
              <TableContainer columns={columns} data={allSurveys} />
            ) : (
              <div>&nbsp;Loading all surveys...</div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </Col>
  );
};

export default AllocatedSurveyDataCsoAdmin;